import { Loader, Snackbar, ThemeProvider, Typography } from '@finam/web-ui-kit';
import React, { useRef } from 'react';
import './App.scss';
import ManagerContacts from './Components/ManagerContacts';
import { SideStepsPanel } from './Components/SideStepsPanel';
import DocumentsUploadStep from './Components/Steps/DocumentsUploadStep';
import SigningStep from './Components/Steps/SigningStep';
import UNEPStep from './Components/Steps/UNEPStep';
import Modal from 'react-modal';
import { DismissCircle } from '@finam/web-ui-kit/Icons/Dismiss';
import { InfoData } from './Services/RequestsData';
import TxAuthWidget, { Options } from '@finam/tx-auth-widget/build';
import { TokenContext } from './TokenContext';
import { FinalStep } from './Components/Steps/FinalStep';
import SocialStep from './Components/Steps/SocialStep';
import SelectHireDateStep from './Components/Steps/SelectHireDateStep';
import OfferStep from './Components/Steps/OfferStep';
import { WebService } from './Services/WebService';
import MeetingLink from './Components/Meetinglink';
import { isEdge, isSafari } from 'react-device-detect';
import ReactModal from 'react-modal';

interface IState {
  currentStep: number;
  errorMessage: string;
  userToken?: string;
  isLoading: boolean;
  isInfoPanelOpen: boolean;
  requestData: InfoData;
  isClient: boolean;
}

export default class App extends React.Component<{}, IState> {
  private readonly widgetElementRef: React.RefObject<HTMLDivElement>;

  constructor(props: any) {
    super(props);
    this.state = { isLoading: true, isInfoPanelOpen: false, currentStep: 0, errorMessage: '', requestData: { candidateGUID: '', managerGUID: '', step: 0, slotId: 0, managerURL: '' }, isClient: false };
    this.widgetElementRef = React.createRef();
  }

  componentDidMount() {
    this.initAuth();
  }

  private GetUserData(token: string) {
    new WebService(token).GetUserData().then((res: any) => {
      if (res.success) {
        this.setState({ requestData: res.requestData, isLoading: false, currentStep: res.requestData!.step })
      }
      else {
        this.setState({ errorMessage: res.exception, isLoading: false })
      }
    });

  }

  private checkIfSafari(): boolean {
    const userAgentString = navigator.userAgent;
    const chromeAgent = userAgentString.indexOf("Chrome") > -1;
    // Detect Safari 
    let safariAgent = userAgentString.indexOf("Safari") > -1;

    // Discard Safari since it also matches Chrome 
    if ((chromeAgent) && (safariAgent)) safariAgent = false;
    return safariAgent;
  }


  private async initAuth() {
    const options: Options = {
      variant: 'finam',
      appName: 'FinamTrade',
      appVersion: '1.0.0',
      lang: 'ru',
      theme: 'light',
      env: 'prod',
      //provider: "PREBOARDING_TFA",
      provider: "PREBOARDING",
      events: {
        onLoginSuccess: (res) => {
          if (res) {
            this.GetUserData(res.token)
          }
        }
      }
    };
    const widget = await TxAuthWidget.new(options);
    widget.subscribeJWT((res) => {
      console.log('subscribeJWT', res);
      this.setState({ userToken: res ? res.token : undefined });
      if (res) {
        widget.unmount();
      } else if (this.widgetElementRef.current) {
        widget.mount(this.widgetElementRef.current);
      }
    });
  }

  private errorHandle(shortMessage: string, fullMessage: string): void {
    console.log(fullMessage);
    this.setState({ errorMessage: shortMessage });
  }

  render(): React.ReactNode {
    return <ThemeProvider><TokenContext.Provider value={{ token: this.state.userToken || '' }}>{this.renderSafariAlarm()}{this.renderBody()}</TokenContext.Provider></ThemeProvider>
  }

  renderSafariAlarm() {
    return this.checkIfSafari() && <div style={{ color: "red" }} >Приносим извинения, но данный сайт не поддерживает браузер Safari. Не весь функционал может работать корректно. Мы рекомендуем использовать Google Chrome.</div>

  }

  renderBody(): JSX.Element {
    const renderStepBody = () => {
      if (this.state.currentStep == 2)
        window.location.replace('https://www.finam.ru/landings/otkrytie-scheta/?int_source=finam_main&int_medium=button&int_campaign=open_account&from=finam_main_button_open_account');
      switch (this.state.currentStep) {
        case 1:
          return <OfferStep endAction={() => this.GetUserData(this.state.userToken || '')} passed={this.state.requestData.step > 1} />
        case 3:
          return <SelectHireDateStep endAction={() => this.GetUserData(this.state.userToken || '')} selectedSlotId={this.state.requestData?.slotId || -1} />
        case 4:
          return <UNEPStep onError={(short, full) => this.errorHandle(short, full)} endAction={() => this.GetUserData(this.state.userToken || '')} />
        case 5:
          return <DocumentsUploadStep onError={(short: any, full: any) => this.errorHandle(short, full)} isClient={this.state.isClient} />
        case 6:
          return <SocialStep userGuid={this.state.requestData.candidateGUID} />
        case 7:
          return <SigningStep endAction={() => this.GetUserData(this.state.userToken || '')} />
        case 8:
          return <FinalStep />
        default:
          return <p>'Не удалось определить шаг процесса'</p>;
      }
    }

    return <div className='app'>
      {!this.state.userToken && <div className='txAuthWrapper' ref={this.widgetElementRef}></div>}
      {this.state.userToken && <div><div className='app-content'>
        <SideStepsPanel
          currentStep={this.state.currentStep || 0}
          currentMaxStep={this.state.requestData.step}
          onStepChange={(step: number) => { this.setState({ currentStep: step }) }}
          slotId={this.state.requestData?.slotId}
          managerInfo={!!this.state.requestData?.managerGUID ? { guid: this.state.requestData?.managerGUID, telegram: this.state.requestData?.managerURL } : undefined}
          emplManagerInfo={!!this.state.requestData?.emplManagerGUID ? { guid: this.state.requestData?.emplManagerGUID, telegram: this.state.requestData?.emplManagerURL } : undefined}
          meetingLink={this.state.requestData?.meetingLink}
        />
        <div className='content'>
          <div className='step-body'>
            {renderStepBody()}
          </div>
          {/* {!!this.state.requestData.meetingLink && <MeetingLink link={this.state.requestData.meetingLink} />} */}
        </div>
      </div>
        <Modal isOpen={this.state.isInfoPanelOpen}
          contentLabel='Информация' ariaHideApp={false}
          style={
            { content: { left: '25%', right: 'auto', bottom: 'auto', marginRight: '400px', height: '90%', overflowY: 'scroll' } }
          }>
        </Modal>
        <Snackbar
          open={!!this.state.errorMessage}
          message={this.state.errorMessage}
          icon={<DismissCircle />}
          ClickAwayListenerProps={{ onClickAway: () => { this.setState({ errorMessage: '' }) } }}
          onClose={() => { this.setState({ errorMessage: '' }) }}
        />
      </div>}
    </div>
  }
}

